<template>
    <div class="menu-mobile">
        <div class="menu-mobile-header">
            <div class="button-close" @click="openMobileMenu">
                <span class="pp-icon-close"></span>
            </div>
            <div class="phone">
                <a class="phone-value" :href="'tel:' + pizzeriaInfo.phone_full">{{pizzeriaInfo.phone_short}}</a>
            </div>
        </div>
        <div class="menu-mobile-body">
            <ButtonLocation></ButtonLocation>
            <div class="language">
                {{ phrases.TEXT_CHOOSE_LANGUAGE }}
                <ButtonLang></ButtonLang>
            </div>
            <div class="header-menu">
                <div class="menu-item" v-for="(menuItem, index) in headerMenu" :key="index">
                    <a class="menu-item-link" :href="menuItem.link" target="_blank">{{menuItem.title}}</a>
                </div>
            </div>
        </div>
        <div class="menu-mobile-footer">
            <div class="header-buttons">
                <ButtonPersonal></ButtonPersonal>
                <ButtonBasket></ButtonBasket>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import ButtonLocation from "./buttons/ButtonLocation";
    import ButtonPersonal from "./buttons/ButtonPersonal";
    import ButtonBasket from "./buttons/ButtonBasket";
    import ButtonLang from "./buttons/ButtonLang";
    import Utils from "./Utils";

    export default {
        name: "MobileMenu",
        computed: {
            ...mapGetters('order', {
                total: 'total',
            }),
            ...mapGetters('user', {
                isAuthorize: 'isAuthorize',
                bonuses: 'getBonuses',
            }),
            ...mapGetters('app', {
                phrases: 'getPhrases',
                headerMenu: 'getHeaderMenu',
                pizzeriaInfo: 'getPizzeriaInfo',
            }),
        },
        components: {
            ButtonLocation,
            ButtonPersonal,
            ButtonBasket,
            ButtonLang,
        },
        mixins: [Utils],
        mounted() {
            this.addFixedBodyClass(true);
        },
        destroyed() {
            this.addFixedBodyClass(false);
        }
    }
</script>

<style scoped>

</style>
